import {
  isThemeApp,
  ThemeApp,
  THEMES,
} from '@src/main/ui/components/common/ThemeProvider/ThemeProvider';
import {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

interface ContextState {
  theme: ThemeApp;
  themes: ThemeApp[];
  setTheme: (themeApp: ThemeApp) => void;
}

const UserThemeContext = createContext<ContextState>({} as ContextState);

export const UserThemeContextProvider: FC<PropsWithChildren> = ({ children }) => {
  const [theme, setTheme] = useState<ThemeApp>('Corporate');
  const localStorageKey = 'UserTheme';

  useEffect(() => {
    const appTheme = localStorage.getItem(localStorageKey);
    if (appTheme && isThemeApp(appTheme)) {
      setTheme(appTheme);
    }
  }, []);

  const values = useMemo(
    () => ({
      theme,
      themes: THEMES,
      setTheme: (themeApp: ThemeApp): void => {
        localStorage.setItem(localStorageKey, themeApp.toString());
        setTheme(themeApp);
      },
    }),
    [theme],
  );

  return <UserThemeContext.Provider value={values}>{children}</UserThemeContext.Provider>;
};

export const useUserThemeContext = (): ContextState => useContext(UserThemeContext);
